import type React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthRedirect } from "@/hooks/useAuthRedirect";

const AuthCallbackPage: React.FC = () => {
	const navigate = useNavigate();
	useAuthRedirect(); // useAuthRedirectフックを使用

	useEffect(() => {
		// ローディング状態を表示するためのタイマーを設定
		const timer = setTimeout(() => {
			console.log("リダイレクトタイムアウト");
			navigate("/login"); // タイムアウト時にログインページにリダイレクト
		}, 10000); // 10秒後にタイムアウト

		return () => clearTimeout(timer); // コンポーネントのアンマウント時にタイマーをクリア
	}, [navigate]);

	return (
		<div className="flex items-center justify-center min-h-screen">
			<div className="text-center">
				<h1 className="text-2xl font-bold mb-4">認証処理中...</h1>
				<p>しばらくお待ちください。自動的にリダイレクトされます。</p>
				{/* ここにローディングスピナーなどを追加することもできます */}
			</div>
		</div>
	);
};

export default AuthCallbackPage;
